<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 v-if="!ctnSheet">
         <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field v-model="searchCtnSheets" label="Search"></v-text-field>
          </v-card-title>
          <v-data-table :items="ctnSheetItems" :loading="gettingCtnSheets" :search="searchCtnSheets" item-key="id" :pagination.sync="ctnPagination"
            :headers="ctnSheetHeaders">
            <template slot="items" slot-scope="props">
              <tr @click="ctnSheet = props.item.key; ctnContacts = props.item.contacts; ctnSheetNote = props.item.note; qnq = props.item.qnq; customerPO = props.item.customerPO; ctnSheetDocs = props.item.attachedDocs; selectedTemplates = props.item.selectedTemplates" :class="props.item.rejected ? 'error' : ''">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.customer }}</td>
                <td>{{ props.item.BDM }}</td>
                <td>{{ props.item.note | lastNote }}</td>
                <td>{{ props.item.LastActionDate | formatDateTime }}</td>
                <td>{{ props.item.LastActionUser }}</td>
                <td>{{ props.item.Status }}</td>
                <td>
                  <v-btn icon class="mx-0" @click.stop="deleteOrderObj = props.item;deleteModal = true">
                    <v-icon :color="props.item.rejected ? 'grey darken-4' : 'pink'">delete</v-icon>
                  </v-btn>
              </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="newVehicleData.length > 0">
        <v-layout row>
          <v-btn color="primary" @click="ctnSheet = null; newVehicleData = []" class="mb-2">Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveDialog = true" :loading="saving" :disabled="submittingCtnSheet || updating || rejecting">Save</v-btn>
        </v-layout>
        <v-data-table :items="newVehicleData" hide-actions :loading="gettingVehicleData" :search="searchVehicleData" item-key="id"
          :pagination.sync="pagination" :headers="vehicleDataHeaders">
          <template slot="headers" slot-scope="props">
                  <tr>
                    <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.class && header.class.indexOf('group-header') !== -1 ? 'group-header' : '']" :style="header.align ? 'text-align:' + header.align : ''"
                      @click="changeSort(header.value)">
                      <v-icon small>arrow_upward</v-icon>
                      <span>{{ header.text }}</span>
                    </th>
                  </tr>
                  <tr>
                    <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.class && header.class.indexOf('group-header') !== -1 ? 'group-header' : '']" :style="header.align ? 'text-align:' + header.align : ''">
                      <v-btn v-if="header.class && header.class.indexOf('group-header') !== -1 && header.hasExtras" small icon :flat="header.class && header.class.indexOf('show') === -1"
                        color="primary" @click="toggleGroup(header.value)">
                        <v-icon class="group-hide-icon" :color="header.class && header.class.indexOf('show') === -1 ? 'primary' : 'white'">add</v-icon>
                      </v-btn>
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr v-if="props.index === 0">
                    <td></td>
                    <template v-for="(template, index) in selectedTemplates">
                      <td :key="'checkAll-' + index" class="text-xs-center">
                        <v-checkbox hide-details v-model="allItemsInstalledDevices[template.id]" @change="changeInstalledDeviceAll(template.id)"
                          class="text-xs-center"></v-checkbox>
                      </td>
                      <template v-for="(templateExtra, extraIndex) in template.extras">
                        <td :class="(!allItemsInstalledDevices[template.id] ? 'grey lighten-2 ' : '' ) + 'col-' + template.id" v-show="template.visible" v-if="templateExtra.permissions.sales === 'write'" :key="'x-' + index + '-' + extraIndex">
                          <v-edit-dialog :return-value.sync="allItems[template.id][templateExtra.name]" v-if="allItemsInstalledDevices[template.id] && templateExtra.permissions.sales === 'write'" @save="changeExtraAll(template.id, templateExtra.name)" large lazy persistent>
                            <div>{{ allItems[template.id][templateExtra.name] }}</div>
                            <v-select slot="input" autofocus single-line v-if="selectedTemplates[index]['extras'][extraIndex]['type'] === 'choice'" :label="selectedTemplates[index]['extras'][extraIndex]['name']" :items="selectedTemplates[index]['extras'][extraIndex]['options']" v-model="allItems[template.id][templateExtra.name]" :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true" :clearable="selectedTemplates[index]['extras'][extraIndex]['default'] === '' ? true : false">
                            </v-select>
                            <v-text-field slot="input" autofocus single-line type="text" v-else-if="selectedTemplates[index]['extras'][extraIndex]['type'] === 'text'"
                              :label="selectedTemplates[index]['extras'][extraIndex]['name']" v-model="allItems[template.id][templateExtra.name]"
                              :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true">
                            </v-text-field>
                            <v-text-field slot="input" autofocus single-line type="number" :step="selectedTemplates[index]['extras'][extraIndex]['step']" v-else
                              :label="selectedTemplates[index]['extras'][extraIndex]['name']" v-model="allItems[template.id][templateExtra.name]"
                              :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true">
                            </v-text-field>
                          </v-edit-dialog>
                          <template v-else>{{ allItems[template.id][templateExtra.name] }}</template>
                        </td>
                      </template>
                    </template>
                  </tr>
                  <tr>
                    <td @click="updateVehicleRegDialog(props.item.id)" :style="['cursor:pointer;', props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;']">{{ props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC'}}</td>
                    <template v-for="(template, index) in selectedTemplates">
                      <td :key="props.item.id + '-' + index" class="text-xs-center">
                        <v-checkbox hide-details v-model="props.item.installedDevices[template.id]" @change="changeInstalledDevice(props.item.id, template.id)"
                          class="text-xs-center"></v-checkbox>
                      </td>
                      <template v-for="(templateExtra, extraIndex) in template.extras">
                        <td style="border: solid 1px #eee!important;" :class="(props.item.installedDevices[template.id] && props.item.devices[template.id] && props.item.devices[template.id][templateExtra.name] === '' ? 'blue lighten-4 ' : '') + (!props.item.installedDevices[template.id] ? 'grey lighten-2 ' : '' ) + 'col-' + template.id" v-show="template.visible" v-if="templateExtra.permissions.sales === 'write'" :key="props.item.id + '-' + index + '-' + extraIndex">
                          <v-edit-dialog :return-value.sync="props.item.devices[template.id][templateExtra.name]" v-if="props.item.devices[template.id] && templateExtra.permissions.sales === 'write'"
                            large lazy persistent @open="openEditDialog(props.index, templateExtra.name.replace(new RegExp(' ', 'g'), '@'))" @save="nextRow(props.index, templateExtra.name.replace(new RegExp(' ', 'g'), '@'))" :ref="'edit-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index">
                            <div>{{ props.item.devices[template.id][templateExtra.name] }}</div>
                            <v-select slot="input" autofocus single-line v-if="selectedTemplates[index]['extras'][extraIndex]['type'] === 'choice'" :label="selectedTemplates[index]['extras'][extraIndex]['name']"
                              :items="selectedTemplates[index]['extras'][extraIndex]['options']" v-model="props.item.devices[template.id][templateExtra.name]"
                              :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true" :clearable="selectedTemplates[index]['extras'][extraIndex]['default'] === '' ? true : false"
                               :ref="'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index">
                            </v-select>
                            <v-text-field slot="input" autofocus single-line type="text" v-else-if="selectedTemplates[index]['extras'][extraIndex]['type'] === 'text'"
                              :label="selectedTemplates[index]['extras'][extraIndex]['name']" v-model="props.item.devices[template.id][templateExtra.name]"
                              :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true" :ref="'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index">
                            </v-text-field>
                            <v-text-field slot="input" autofocus single-line type="number" :step="selectedTemplates[index]['extras'][extraIndex]['step']" v-else
                              :label="selectedTemplates[index]['extras'][extraIndex]['name']" v-model="props.item.devices[template.id][templateExtra.name]"
                              :required="selectedTemplates[index]['extras'][extraIndex]['required'] === true" :ref="'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index">
                            </v-text-field>

                          </v-edit-dialog>
                          <template v-else>{{ props.item.devices[template.id] ? props.item.devices[template.id][templateExtra.name] : '' }}</template>
                        </td>
                      </template>
                    </template>
                  </tr>
                </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ searchVehicleData }}" found no results.
          </v-alert>
        </v-data-table>
        <v-layout row v-if="role === 'Sales'">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateDialog = true" :loading="updating" :disabled="saving || submittingCtnSheet || rejecting">Update</v-btn>
        </v-layout>  
        <v-layout row wrap v-else>
          <v-btn color="error" @click="rejectDialog = true;" :loading="rejecting" :disabled="saving || updating || submittingCtnSheet">Reject</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="acceptDialog = true;" :loading="submittingCtnSheet" :disabled="saving || updating || rejecting">Accept</v-btn>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 class="mt-3">
            <h3>Note: </h3>
            <p v-html="ctnSheetNote"></p>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 class="mt-3" v-if="Object.keys(finance).length > 0">
            <h3>Finance</h3>
            <div v-for="template in selectedTemplates" :key="template.id" class="my-3">
                    <h4>{{template.name}}</h4>
                    <v-select multiple :items="paymentMethods" chips label="Payment Method(s)" v-model="finance[template.id]['paymentMethods']"></v-select>
                    <v-select label="Contact Term" :items="contractTerms" v-model="finance[template.id]['contractTerm']"></v-select>
                    <v-select label="Currency" :items="currencies" v-model="finance[template.id]['currency']"></v-select>
                    <v-text-field label="Upfront Payment" type="number" :prefix="currencySymbolFromVal(finance[template.id]['currency'])" step="0.01" v-if="finance[template.id]['paymentMethods'].includes('upfront-payment')" v-model="finance[template.id]['upfrontPayment']"></v-text-field>
                    <v-text-field label="Installation Payment" type="number" :prefix="currencySymbolFromVal(finance[template.id]['currency'])" step="0.01" v-if="finance[template.id]['paymentMethods'].includes('upfront-installation')" v-model="finance[template.id]['installationPayment']"></v-text-field>
                    <v-text-field label="Rental Payment" type="number" :prefix="currencySymbolFromVal(finance[template.id]['currency'])" step="0.01" v-if="finance[template.id]['paymentMethods'].includes('rental')" v-model="finance[template.id]['rentalPayment']"></v-text-field>
                    <v-select label="Rental Frequency" :items="rentalFrequencies" v-if="finance[template.id]['paymentMethods'].includes('rental')" v-model="finance[template.id]['rentalFrequency']"></v-select>
                    <v-select label="lessor" :items="lessors" v-if="finance[template.id]['paymentMethods'].includes('lease')" v-model="finance[template.id]['lessor']"></v-select>
                    <v-text-field label="Lease Payment" type="number" :prefix="currencySymbolFromVal(finance[template.id]['currency'])" step="0.01" v-if="finance[template.id]['paymentMethods'].includes('lease')" v-model="finance[template.id]['leasePayment']"></v-text-field>
                    <v-select label="Lease Frequency" :items="leaseFrequencies" v-if="finance[template.id]['paymentMethods'].includes('lease')" v-model="finance[template.id]['leaseFrequency']"></v-select>
                    <v-select label="Warranty" :items="warranties" v-model="finance[template.id]['warranty']"></v-select>
                    <v-select label="Warranty Type" :items="warrantyType" v-model="finance[template.id]['warrantyType']" v-if="finance[template.id]['warranty'] !== 'n/a'"></v-select>
                  </div>
          </v-flex>
        </v-layout>
        <v-layout justify-start align-center wrap>
          <h3 class="title">Attached Documents</h3>
          <upload-btn :title="'Attach New Document'" :fileChangedCallback="attachFile">
            <template slot="icon">
              <v-icon color="white">mdi-paperclip</v-icon>
            </template>
          </upload-btn>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
              <v-list>
                <v-list-tile v-for="doc in ctnSheetDocs" :key="doc.name">
                  <v-list-tile-action>
                    <v-btn icon color="error" @click="deleteCtnSheetDoc(doc.name)" :disabled="deletingCtnSheetDoc">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <a :href="doc.downloadUrl" target="_BLANK">{{doc.name}}</a>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-list>
                <v-list-tile v-for="(fileObj, key) in attachedDocs" :key="fileObj.file.name" two-line>
                  <v-list-tile-action>
                    <v-btn icon color="error" @click="attachedDocs.splice(key, 1)" :disabled="submittingCtnSheet">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span class="body-2">{{fileObj.file.name}}</span>
                      <span class="caption ml-1">{{fileObj.file.size | formatBytes}}</span>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      <v-progress-linear
                        :value="fileObj.Progress"
                        :color="fileObj.State === 0 ? 'primary' : fileObj.State === 1 ? 'blue' : fileObj.State === 2 ? 'warning' : fileObj.State === 3 ? 'success' : fileObj.State === 4 ? 'error' : 'primary'"></v-progress-linear>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-dialog v-model="rejectDialog" persistent max-width="290">
        <v-card>
          <v-card-title>Reject CTN Sheet</v-card-title>
          <v-card-text>
            <v-textarea 
              v-model="rejectNote"
              auto-grow
              rows="3"
              label="Note"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="rejectDialog = false" :disabled="submittingCtnSheet">Close</v-btn>
            <v-btn color="error" flat @click="reject" :loading="rejecting" :disabled="rejecting">Reject</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="acceptDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Accept CTN Sheet</v-card-title>
          <v-card-text>
            <v-textarea 
              v-model="acceptNote"
              auto-grow
              rows="3"
              label="Note"></v-textarea>
            <v-autocomplete
              :items="suppliers"
              v-model="projectSupplier" 
              label="Assign to Supplier" 
              item-text="name" 
              item-value="key">
            </v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="acceptDialog = false" :disabled="submittingCtnSheet">Close</v-btn>
            <v-btn color="success" flat @click="submit" :loading="submittingCtnSheet" :disabled="submittingCtnSheet">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="updateDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Update CTN Sheet</v-card-title>
          <v-card-text>
            <v-textarea 
              v-model="updateNote"
              auto-grow
              rows="3"
              label="Note"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="updateDialog = false" :disabled="submittingCtnSheet">Close</v-btn>
            <v-btn color="success" flat @click="updateCtnSheet" :loading="updating" :disabled="updating">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="saveDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Save CTN Sheet</v-card-title>
          <v-card-text>
            <v-textarea 
              v-model="saveNote"
              auto-grow
              rows="3"
              label="Note"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="saveDialog = false" :disabled="saving">Close</v-btn>
            <v-btn color="success" flat @click="save" :loading="updating" :disabled="updating">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog max-width="350" v-model="vehicleRegDialog">
        <v-card>
          <v-card-title class="headline">Update Vehicle Registration</v-card-title>
          <v-card-text>
            <v-text-field v-model="vehicleRegDialogData.Reg" label="Vehicle Reg." @keyup.enter="saveVehicleReg" autofocus ref="updateVehicleRegInput"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="saveVehicleReg" color="success" flat>Save</v-btn>
            <v-btn @click="vehicleRegDialog = false" color="grey" flat>Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog max-width="350" v-model="deleteModal">
        <v-card>
          <v-card-title class="headline">Delete Order</v-card-title>
          <v-card-text>
            Are you sure you wish to delete order {{deleteOrderObj.id}}?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="deleteOrder" color="success" flat :loading="deletingOrder">Yes</v-btn>
            <v-btn @click="deleteModal = false" color="grey" flat>Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import { updateAuditLog, fireStore, storage, sendEmail } from '../firebase'
import UploadButton from 'vuetify-upload-button'
import moment from 'moment'
export default {
  components: {
    'upload-btn': UploadButton
  },
  props: ['ctnSheetProp'],
  data () {
    return {
      ctnSheet: null,
      pagination: {
        sortBy: 'VehicleReg',
        rowsPerPage: -1,
        page: 1,
        descending: false
      },
      templates: [],
      allItems: {},
      allItemsInstalledDevices: {},
      searchVehicleData: '',
      customer: null,
      customerShortName: null,
      ctnSheetRef: null,
      existingVehicleData: [],
      newVehicleData: [],
      customerList: [],
      templateDefaults: {},
      accepted: null,
      rejected: null,
      gettingVehicleData: false,
      gettingCtnSheets: false,
      searchCtnSheets: '',
      ctnPagination: {
        sortBy: 'id',
        rowsPerPage: 25,
        page: 1,
        descending: true
      },
      ctnSheetHeaders: [{
        text: 'Reference No.',
        value: 'id'
      },
      {
        text: 'Customer',
        value: 'customer'
      },
      {
        text: 'BDM',
        value: 'BDM'
      },
      {
        text: 'Last Note',
        value: 'note'
      },
      {
        text: 'Last Action Date',
        value: 'LastActionDate'
      },
      {
        text: 'Last Actioned By',
        value: 'LastActionUser'
      },
      {
        text: 'Status',
        value: 'Status'
      }],
      ctnSheetList: [],
      projectSupplier: null,
      acceptDialog: false,
      rejectDialog: false,
      updateDialog: false,
      saveDialog: false,
      submittingCtnSheet: false,
      vehicleRegDialog: false,
      vehicleRegDialogData: {
        Reg: null,
        itemId: null
      },
      saving: false,
      rejecting: false,
      updating: false,
      ctnSheetNote: '',
      ctnContacts: '',
      acceptNote: '',
      rejectNote: '',
      qnq: '',
      customerPO: '',
      updateNote: '',
      saveNote: '',
      selectedTemplates: [],
      deleteOrderObj: {id: null},
      deleteModal: false,
      deletingOrder: false,
      ctnSheetDocs: [],
      attachedDocs: [],
      deletingCtnSheetDoc: false,
      paymentMethods: [
        {text: 'Upfront Payment', value: 'upfront-payment'},
        {text: 'Upfront Installation', value: 'upfront-installation'},
        {text: 'Rental', value: 'rental'},
        {text: 'Lease', value: 'lease'}
      ],
      contractTerms: [
        {text: '30 Days', value: '30days'},
        {text: '60 Days', value: '60days'},
        {text: '90 Days', value: '90days'},
        {text: '6 Months', value: '6months'},
        {text: '9 Months', value: '9months'},
        {text: '12 Months', value: '12months'},
        {text: '18 Months', value: '18months'},
        {text: '24 Months', value: '24months'},
        {text: '36 Months', value: '36months'},
        {text: '48 Months', value: '48months'},
        {text: '60 Months', value: '60months'},
        {text: 'N/A', value: 'n/a'},
        {text: 'Demo', value: 'demo'}
      ],
      warranties: [
        {text: '30 Days', value: '30days'},
        {text: '60 Days', value: '60days'},
        {text: '90 Days', value: '90days'},
        {text: '6 Months', value: '6months'},
        {text: '9 Months', value: '9months'},
        {text: '12 Months', value: '12months'},
        {text: '18 Months', value: '18months'},
        {text: '24 Months', value: '24months'},
        {text: '36 Months', value: '36months'},
        {text: '48 Months', value: '48months'},
        {text: '60 Months', value: '60months'},
        {text: 'N/A', value: 'n/a'}
      ],
      warrantyType: [
        {text: 'Full', value: 'full'},
        {text: 'Parts', value: 'parts'},
        {text: 'Labour', value: 'labour'}
      ],
      currencies: [
        {text: '£', value: 'gbp'},
        {text: '€', value: 'euro'}
      ],
      rentalFrequencies: [
        {text: 'Monthly', value: 'monthly'},
        {text: 'Quarterly', value: 'quarterly'},
        {text: 'Annual', value: 'annual'}
      ],
      lessors: [
        {text: 'LDF (White Oak)', value: 'ldf'},
        {text: 'Lease Telecom', value: 'lease-telecom'},
        {text: 'Grenke', value: 'grenke'}
      ],
      leaseFrequencies: [
        {text: 'Monthly', value: 'monthly'},
        {text: 'Quarterly', value: 'quarterly'}
      ],
      finance: {},
      test: ''
    }
  },
  created () {
    if (this.ctnSheetProp) {
      this.ctnSheet = this.ctnSheetProp
    }
    this.getCustomers()
    this.getCtnSheets()
    this.getTemplates()
    this.$store.dispatch('fetchSuppliers')
  },
  watch: {
    ctnSheet (value) {
      if (value) {
        this.getVehicleData()
      }
    },
    role () {
      this.getCtnSheets()
    }
  },
  filters: {
    formatDate (val) {
      return val !== undefined && val !== null ? moment(val).format('DD/MM/YYYY') : null
    },
    formatDateTime (val) {
      return val !== undefined && val !== null ? moment(val).format('DD/MM/YYYY HH:mm') : null
    },
    formatBytes (bytes) {
      if (bytes == 0) return '0 Bytes'
      var k = 1024
      const dm = 2
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    lastNote (val) {
      const arr = val.split('<br>')
      return arr[arr.length - 1]
    }
  },
  methods: {
    getCustomers () {
      this.gettingCustomers = true
      fireStore.collection('Customers').get()
      .then(snap => {
        snap.forEach(doc => {
          this.customerList.push({key: doc.id, name: doc.data().customerName, shortName: doc.data().shortName, BDM: doc.data().BDM || null, BDMEmail: doc.data().BDMEmail || null})
        })
        this.customerList.sort(function (a, b) {
          const aName = a.name.toLowerCase()
          const bName = b.name.toLowerCase()
          return aName < bName ? -1 : aName > bName ? 1 : 0
        })
        this.gettingCustomers = false
      })
    },
    getTemplates () {
      fireStore.collection('productType').get()
      .then(snap => {
        let defaults = {}
        snap.forEach(doc => {
          if (doc.id !== '' && doc.data().hidden !== true) {
            let obj = doc.data()
            obj.id = doc.id
            obj.visible = false
            this.templates.push(obj)
            defaults[obj.id] = {}
            if (obj.extras) {
              obj.extras.forEach(extra => {
                defaults[obj.id][extra.name] = extra.default
              })
            }
          }
        })
        this.templates.sort((a, b) => {
          return a.Index - b.Index
        })
        this.templateDefaults = Object.assign({}, this.templateDefaults, defaults)
        this.allItems = Object.assign({}, this.allItems, defaults)
      })
    },
    getCtnSheets () {
      this.gettingCtnSheets = true
      this.ctnSheetList = []
      if (this.role === 'Sales') {
        fireStore.collection('CTN Sheets').where('rejected', '==', true).get()
        .then(snap => {
          snap.forEach(doc => {
            let data = doc.data()
            this.ctnSheetList.push({...data, key: doc.id})
          })
          this.gettingCtnSheets = false
        })
      } else {
        fireStore.collection('CTN Sheets').where('accepted', '==', false).get()
        .then(snap => {
          snap.forEach(doc => {
            let data = doc.data()
            this.ctnSheetList.push({...data, key: doc.id})
          })
          this.gettingCtnSheets = false
        })
      }
    },
    getVehicleData () {
      this.gettingVehicleData = true
      fireStore.collection('CTN Sheets').doc(this.ctnSheet).get()
      .then(doc => {
        const data = doc.data()
        this.existingVehicleData = data.existingVehicleData
        this.newVehicleData = data.newVehicleData
        const ctnSheetItem = this.ctnSheetList.find(ctnSheet => { return ctnSheet.key === this.ctnSheet })
        this.finance = ctnSheetItem.finance ? JSON.parse(JSON.stringify(ctnSheetItem.finance)) : {}
        this.ctnSheetRef = data.id
        this.customer = data.customer
        this.accepted = data.accepted
        this.rejected = data.rejected
        this.gettingVehicleData = false
      })
    },
    getVehicles () {
      this.gettingVehicles = true
      fireStore.collection('Vehicles').where('Customer', '==', this.customer).get()
      .then(snap => {
        snap.forEach(doc => {
          const data = doc.data()
          this.vehicleList.push({id: doc.id, vehReg: data.VehicleReg, make: data.Make, model: data.Model, year: data.Year, friendlyId: data.friendlyId})
        })
        this.gettingVehicles = false
      })
    },
    getCtnSheet () {
      this.gettingCtnSheet = true
      this.ctnSheetDocs = []
      fireStore.collection('CTN Sheets').doc(this.ctnSheet).get()
      .then(doc => {
        var data = doc.data()
        this.existingVehicleData = data.existingVehicleData
        this.newVehicleData = data.newVehicleData
        this.customer = data.customer
        this.accepted = data.accepted
        this.rejected = data.rejected
        this.qnq = data.qnq
        this.customerPO = ''
        const storageRef = storage.ref('OrderDocs/' + data.id)
        data.attachedDocs.forEach(fileRef => {
          storageRef.child(fileRef).getDownloadURL().then(function (url) {
            this.ctnSheetDocs.push({name: fileRef, downloadUrl: url})
          }).catch(function (error) {
            console.log(error)
          })
        })
      })
      .catch(error => {
        console.log(error)
      })
    },
    submit () {
      this.submittingCtnSheet = true
      let promises = []
      const storageRef = storage.ref('OrderDocs/' + this.ctnSheetRef)
      this.attachedDocs.forEach((fileObj, index) => {
        promises.push(new Promise((resolve, reject) => {
          let uploadTask = storageRef.child(fileObj.file.name).put(fileObj.file)
          uploadTask.on('state_changed', snapshot => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.attachedDocs[index]['Progress'] = progress
            // switch (snapshot.state) {
            //   case storage.TaskState.PAUSED: // or 'paused'
            //     this.attachedDocs[index]['State'] = 2
            //     break
            //   case storage.TaskState.RUNNING: // or 'running'
            //     this.attachedDocs[index]['State'] = 1
            //     break
            // }
          }, error => {
            // Handle unsuccessful uploads
            this.attachedDocs[index]['State'] = 4
            reject(error)
          }, () => {
            // Handle successful uploads on complete
            this.attachedDocs[index]['Progress'] = 100
            this.attachedDocs[index]['State'] = 3
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.ctnSheetDocs.push({downloadUrl: downloadURL, name: fileObj.file.name})
              resolve()
            })
          })
        })
        )
      })
      Promise.all(promises).then(val => {
        this.attachedDocs = []
        let ctnJobObj = {}
        let newVehicleData = this.newVehicleData
        let existingVehicleData = this.existingVehicleData
        newVehicleData = newVehicleData.sort(function (a, b) {
          const aId = a.id
          const bId = b.id
          if (!aId) {
            return 0
          } else if (!bId) {
            return 1
          }
          return a.id.toUpperCase() > b.id.toUpperCase() ? 1 : 0
        })
        existingVehicleData = existingVehicleData.sort(function (a, b) {
          const aId = a.id
          const bId = b.id
          if (!aId) {
            return 0
          } else if (!bId) {
            return 1
          }
          return a.id.toUpperCase() > b.id.toUpperCase() ? 1 : 0
        })
        newVehicleData.forEach((vehicleData, vehicleIndex) => {
          for (let deviceId in vehicleData.installedDevices) {
            if (!existingVehicleData[vehicleIndex]['installedDevices'].hasOwnProperty(deviceId)) {
              if (!ctnJobObj[vehicleData.id]) {
                ctnJobObj[vehicleData.id] = {}
              }
              if (!ctnJobObj[vehicleData.id]['installedDevices']) {
                ctnJobObj[vehicleData.id]['installedDevices'] = []
              }
              ctnJobObj[vehicleData.id]['installedDevices'].push(deviceId)
            }
          }
          for (let deviceId in vehicleData.devices) {
            if (!ctnJobObj[vehicleData.id]) {
              ctnJobObj[vehicleData.id] = {}
            }
            for (let deviceField in vehicleData.devices[deviceId]) {
              if (!existingVehicleData[vehicleIndex]['devices'][deviceId] || !existingVehicleData[vehicleIndex]['devices'][deviceId].hasOwnProperty(deviceField) || existingVehicleData[vehicleIndex]['devices'][deviceId][deviceField] !== vehicleData.devices[deviceId][deviceField]) {
                if (!ctnJobObj[vehicleData.id]['devices']) {
                  ctnJobObj[vehicleData.id]['devices'] = {}
                }
                if (!ctnJobObj[vehicleData.id]['devices'][deviceId]) {
                  ctnJobObj[vehicleData.id]['devices'][deviceId] = {}
                }
                ctnJobObj[vehicleData.id]['devices'][deviceId][deviceField] = vehicleData.devices[deviceId][deviceField]
              }
            }
            if (!ctnJobObj[vehicleData.id]['finance']) {
              ctnJobObj[vehicleData.id]['finance'] = {}
            }
            if (!ctnJobObj[vehicleData.id]['finance'][deviceId]) {
              ctnJobObj[vehicleData.id]['finance'][deviceId] = {}
            }
            ctnJobObj[vehicleData.id]['finance'][deviceId] = this.finance[deviceId] ? this.finance[deviceId] : {}
          }
        })
        const customerIndex = this.customerList.findIndex(customerListObj => {
          return customerListObj.key === this.customer
        })
        const shortName = this.customerList[customerIndex]['shortName']
        let jobNumbers = []
        let jobNo = ''
        let projectIds = []
        let projectId = ''
        fireStore.collection('Projects').where('Customer', '==', this.customer).get()
        .then((docRef) => {
          docRef.forEach(doc => {
            let projId = doc.data().projectId
            if (projId) {
              projId = projId.replace(/\D/g, '')
              projectIds.push(projId)
            }
          })
          projectIds = projectIds.sort()
          projectIds = projectIds.reverse()
          if (projectIds.length === 0) {
            projectIds.push(0)
          }
          projectId = projectIds[0]
          projectId = 'P-' + shortName + this.zeroFill(parseInt(projectId) + 1, 4)
          let dataToSend = {Customer: this.customer, CreatedDate: moment().format('YYYY-MM-DD'), projectId: projectId, Status: 'CTN Sheet Approved', notes: this.acceptNote ? this.ctnSheetNote + '<br>' + this.acceptNote + ' - ' + this.username : this.ctnSheetNote, attachedDocs: this.ctnSheetDocs ? this.ctnSheetDocs : [], contacts: this.ctnContacts || [], qnq: this.qnq, customerPO: this.customerPO}
          fireStore.collection('Projects').add(dataToSend)
          .then(() => {
            updateAuditLog('add', 'orderApproval', this.user, null, projectId, 'added new project', dataToSend, this.customer)
            fireStore.collection('Jobs').where('Customer', '==', this.customer).get()
            .then((docRef) => {
              docRef.forEach(doc => {
                let JobNo = doc.data().JobNo
                if (JobNo && JobNo.indexOf(shortName) > -1) {
                  JobNo = JobNo.replace(/\D/g, '')
                  jobNumbers.push(JobNo)
                }
              })
              jobNumbers = jobNumbers.sort()
              jobNumbers = jobNumbers.reverse()
              if (jobNumbers.length === 0) {
                jobNumbers.push(0)
              }
              jobNo = jobNumbers[0]
              console.log(ctnJobObj)
              for (let ctnJobKey in ctnJobObj) {
                jobNo++
                let jobTemplates = []
                if (ctnJobObj[ctnJobKey]['installedDevices']) {
                  for (let product of ctnJobObj[ctnJobKey]['installedDevices']) {
                    let template = this.templates.find(template => { return template.id === product })
                    if (template && template.devices !== undefined) {
                      jobTemplates = jobTemplates.concat(template.devices)
                    }
                  }
                }

                if (jobTemplates.indexOf('preCheck') === -1 && jobTemplates.indexOf('5oJKuVseN0PkmvZeDl0J') === -1) {
                  jobTemplates.unshift('preCheck')
                }
                if (jobTemplates.indexOf('Je2nQqSdazW25XWSGkt3') === -1 && jobTemplates.indexOf('5oJKuVseN0PkmvZeDl0J') === -1) {
                  jobTemplates.push('Je2nQqSdazW25XWSGkt3')
                }

                const obj = {
                  Customer: this.customer,
                  Vehicle: ctnJobKey,
                  Status: 0,
                  products: ctnJobObj[ctnJobKey]['installedDevices'] || null,
                  templates: jobTemplates.filter((item, pos) => jobTemplates.indexOf(item) === pos),
                  finance: ctnJobObj[ctnJobKey]['finance'],
                  JobNo: shortName + this.zeroFill(parseInt(jobNo), 4),
                  Project: projectId,
                  newMethod: true,
                  CreatedDate: Date.now()
                }
                if (ctnJobObj[ctnJobKey]['devices']) {
                  obj.extras = {}
                  for (let deviceKey in ctnJobObj[ctnJobKey]['devices']) {
                    obj.extras[deviceKey] = ctnJobObj[ctnJobKey]['devices'][deviceKey]
                    // for (let deviceAttrKey in ctnJobObj[ctnJobKey]['devices'][deviceKey]) {
                    //   obj.extras[deviceAttrKey] = ctnJobObj[ctnJobKey]['devices'][deviceKey][deviceAttrKey]
                    // }
                  }
                }
                if (this.projectSupplier) {
                  obj.Supplier = this.projectSupplier
                }
                if (this.projectDate) {
                  obj.Date = this.projectDate
                }

                if (obj.templates) {
                  fireStore.collection('Jobs').add(obj)
                  updateAuditLog('add', 'orderApproval', this.user, obj.JobNo, obj.Project, 'added job', obj, null)
                }
              }
              let obj = {accepted: true, rejected: false, note: this.acceptNote ? this.ctnSheetNote + '<br>' + this.acceptNote + ' - ' + this.username : this.ctnSheetNote, attachedDocs: this.ctnSheetDocs ? this.ctnSheetDocs : []}
              fireStore.collection('CTN Sheets').doc(this.ctnSheet).update(obj)
              .then(() => {
                const customer = this.customerList.find(customerObj => {
                  return customerObj.key === this.customer
                })
                const id = this.ctnSheetList.find(ctnSheet => {
                  return ctnSheet.key === this.ctnSheet
                }).id
                fireStore.collection('CTNSheetsStatuses').add({key: this.ctnSheet, id: id, Status: 'Accepted', BDM: customer.BDM, BDMEmail: customer.BDMEmail, note: this.acceptNote ? this.ctnSheetNote + '<br>' + this.acceptNote + ' - ' + this.username : this.ctnSheetNote, projectId: projectId, attachedDocs: this.ctnSheetDocs ? this.ctnSheetDocs : []})
                sendEmail('invoice@wearecubo.com; nexusalerts@wearecubo.com;',
                    `Nexus Order Accepted-${this.qnq}-${projectId}-${customer.shortName} ${customer.name}`,
                    `-\n
                    QNQ: ${this.qnq}\n
                    Customer: ${customer.name}\n
                    Customer No: ${customer.shortName}\n
                    Project ID: ${projectId}\n
                    BDM: ${customer.BDM}\n
                    Last Actioned: ${this.username}
                    https://nexus.mycubo.online/#/Project/${customer.key}/p:${projectId}`)
                const index = this.ctnSheetList.findIndex(sheet => {
                  return sheet.key === this.ctnSheet
                })
                let obj = this.ctnSheetList[index]
                obj.accepted = true
                obj.rejected = false
                this.ctnSheetList.splice(index, 1)
                this.acceptDialog = false
                this.ctnSheet = null
                this.newVehicleData = []
                this.submittingCtnSheet = false
              })
            })
          })
        })
      })
    },
    reject () {
      this.rejecting = true
      let promises = []
      const storageRef = storage.ref('OrderDocs/' + this.ctnSheetRef)
      this.attachedDocs.forEach((fileObj, index) => {
        promises.push(new Promise((resolve, reject) => {
          let uploadTask = storageRef.child(fileObj.file.name).put(fileObj.file)
          uploadTask.on('state_changed', snapshot => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.attachedDocs[index]['Progress'] = progress
            // switch (snapshot.state) {
            //   case storage.TaskState.PAUSED: // or 'paused'
            //     this.attachedDocs[index]['State'] = 2
            //     break
            //   case storage.TaskState.RUNNING: // or 'running'
            //     this.attachedDocs[index]['State'] = 1
            //     break
            // }
          }, error => {
            // Handle unsuccessful uploads
            this.attachedDocs[index]['State'] = 4
            reject(error)
          }, () => {
            // Handle successful uploads on complete
            this.attachedDocs[index]['Progress'] = 100
            this.attachedDocs[index]['State'] = 3
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.ctnSheetDocs.push({downloadUrl: downloadURL, name: fileObj.file.name})
              resolve()
            })
          })
        })
        )
      })
      Promise.all(promises).then(val => {
        this.attachedDocs = []
        const obj = {accepted: false, rejected: true, note: this.rejectNote ? this.ctnSheetNote + '<br>' + this.rejectNote + ' - ' + this.username : this.ctnSheetNote, LastActionUser: this.username, LastActionDate: moment().format('YYYY-MM-DD HH:mm:ss'), attachedDocs: this.ctnSheetDocs ? this.ctnSheetDocs : []}
        fireStore.collection('CTN Sheets').doc(this.ctnSheet).update(obj)
        .then(() => {
          const customer = this.customerList.find(customerObj => {
            return customerObj.key === this.customer
          })
          const id = this.ctnSheetList.find(ctnSheet => {
            return ctnSheet.key === this.ctnSheet
          }).id
          fireStore.collection('CTNSheetsStatuses').add({key: this.ctnSheet, id: id, Status: 'Rejected', BDM: customer.BDM, BDMEmail: customer.BDMEmail, note: this.rejectNote ? this.ctnSheetNote + '<br>' + this.rejectNote + ' - ' + this.username : this.ctnSheetNote, attachedDocs: this.ctnSheetDocs ? this.ctnSheetDocs : []})
          const index = this.ctnSheetList.findIndex(sheet => {
            return sheet.key === this.ctnSheet
          })
          sendEmail('invoice@wearecubo.com',
                    `Nexus Order Rejected-${this.qnq}-${customer.shortName} ${customer.name}`,
                    `-\n
                    QNQ: ${this.qnq}\n
                    Customer: ${customer.name}\n
                    Customer No: ${customer.shortName}\n
                    Rejected Note: ${this.rejectNote}\n
                    BDM: ${customer.BDM}\n
                    Last Actioned: ${this.username}\n
                    https://nexus.mycubo.online/#/OrderApproval`)
          let newObj = this.ctnSheetList[index]
          newObj['rejected'] = true
          newObj['note'] = obj.note
          newObj['LastActionUser'] = obj.LastActionUser
          newObj['LastActionDate'] = obj.LastActionDate
          this.ctnSheetList[index] = Object.assign({}, this.ctnSheetList[index], newObj)
          this.ctnSheet = null
          this.newVehicleData = []
          this.rejecting = false
          this.rejectDialog = false
          this.rejectNote = ''
        })
        .catch(error => {
          console.log(error)
          this.rejecting = false
        })
      })
    },
    save () {
      this.saving = true
      let promises = []
      const storageRef = storage.ref('OrderDocs/' + this.ctnSheetRef)
      this.attachedDocs.forEach((fileObj, index) => {
        promises.push(new Promise((resolve, reject) => {
          let uploadTask = storageRef.child(fileObj.file.name).put(fileObj.file)
          uploadTask.on('state_changed', snapshot => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.attachedDocs[index]['Progress'] = progress
            // switch (snapshot.state) {
            //   case storage.TaskState.PAUSED: // or 'paused'
            //     this.attachedDocs[index]['State'] = 2
            //     break
            //   case storage.TaskState.RUNNING: // or 'running'
            //     this.attachedDocs[index]['State'] = 1
            //     break
            // }
          }, error => {
            // Handle unsuccessful uploads
            this.attachedDocs[index]['State'] = 4
            reject(error)
          }, () => {
            // Handle successful uploads on complete
            this.attachedDocs[index]['Progress'] = 100
            this.attachedDocs[index]['State'] = 3
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.ctnSheetDocs.push({downloadUrl: downloadURL, name: fileObj.file.name})
              resolve()
            })
          })
        })
        )
      })
      Promise.all(promises).then(val => {
        this.attachedDocs = []
        fireStore.collection('CTN Sheets').doc(this.ctnSheet).update({newVehicleData: this.newVehicleData, attachedDocs: this.ctnSheetDocs ? this.ctnSheetDocs : [], note: this.saveNote ? this.ctnSheetNote + '<br>' + this.saveNote + ' - ' + this.username : this.ctnSheetNote, qnq: this.qnq, customerPO: this.customerPO})
        .then(() => {
          const index = this.ctnSheetList.findIndex(sheet => {
            return sheet.key === this.ctnSheet
          })
          let obj = this.ctnSheetList[index]
          console.log(index)
          console.log(obj)
          obj.note = this.saveNote ? this.ctnSheetNote + '<br>' + this.saveNote + ' - ' + this.username : this.ctnSheetNote
          this.ctnSheetList[index] = Object.assign({}, this.ctnSheetList[index], obj)
          this.ctnSheet = null
          this.newVehicleData = []
          this.saving = false
          this.saveDialog = false
        })
        .catch(error => {
          console.log(error)
          this.saving = false
        })
      })
    },
    updateCtnSheet () {
      this.updating = true
      const obj = {rejected: false, newVehicleData: this.newVehicleData, LastActionUser: this.username, LastActionDate: moment().format('YYYY-MM-DD HH:mm:ss'), updated: true, note: this.updateNote ? this.ctnSheetNote + '<br>' + this.updateNote + ' - ' + this.username : this.ctnSheetNote}
      fireStore.collection('CTN Sheets').doc(this.ctnSheet).update(obj)
      .then(() => {
        const index = this.ctnSheetList.findIndex(sheet => {
          return sheet.key === this.ctnSheet
        })
        this.ctnSheet = null
        this.newVehicleData = []
        this.ctnSheetList.splice(index, 1)
        this.updating = false
        this.updateDialog = false
      })
      .catch(error => {
        console.log(error)
        this.updating = false
      })
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    toggleGroup (templateId) {
      const index = this.selectedTemplates.findIndex(template => {
        return template.id === templateId
      })
      this.selectedTemplates[index]['visible'] = !this.selectedTemplates[index]['visible']
    },
    changeInstalledDevice (itemId, templateId) {
      const index = this.newVehicleData.findIndex(data => {
        return data.id === itemId
      })
      const existingIndex = this.existingVehicleData.findIndex(data => {
        return data.id === itemId
      })
      if (this.newVehicleData[index]['installedDevices'][templateId]) {
        if (this.existingVehicleData[existingIndex]['devices'][templateId]) {
          this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.existingVehicleData[existingIndex]['devices'][templateId])
        } else {
          this.$set(this.newVehicleData[index]['devices'], templateId, {})
          // this.newVehicleData[index]['devices'][templateId] = {}
          this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.newVehicleData[index]['devices'][templateId], this.templateDefaults[templateId])
          if (templateId === 'IGVjrrgemWhH8zki8yBZ') {
            this.newVehicleData[index]['devices'][templateId]['[Tacho Smart] VU Part Number'] = this.newVehicleData[index]['VUPartNo']
          }
        }
      } else {
        delete this.newVehicleData[index]['devices'][templateId]
        delete this.newVehicleData[index]['installedDevices'][templateId]
      }
    },
    updateVehicleRegDialog (itemId) {
      const index = this.newVehicleData.findIndex(vehicle => {
        return vehicle.id === itemId
      })
      this.vehicleRegDialogData.Reg = this.newVehicleData[index]['VehicleReg']
      this.vehicleRegDialogData.itemId = itemId
      this.vehicleRegDialog = true
      this.$nextTick(this.$refs.updateVehicleRegInput.focus)
    },
    saveVehicleReg () {
      const newReg = this.vehicleRegDialogData.Reg.toUpperCase().replace(/\s/g, '')
      const vehId = this.vehicleRegDialogData.itemId
      const index = this.newVehicleData.findIndex(vehicle => {
        return vehicle.id === vehId
      })
      if (this.newVehicleData[index]['VehicleReg'] !== newReg) { // Only update firestore if reg has changed
        let batch = fireStore.batch()
        const vehDoc = fireStore.collection('Vehicles').doc(vehId)
        const ctnDoc = fireStore.collection('CTN Sheets').doc(this.ctnSheet)
        // Take a copy of newVehicleData and existingVehicleData, update the reg on the copy and update Firestore with these modified copies. We're using copies instead of the original data just in case the Firestore call fails.
        let newVehicleDataTemp = this.newVehicleData
        let existingVehicleDataTemp = this.existingVehicleData
        newVehicleDataTemp[index]['VehicleReg'] = newReg
        existingVehicleDataTemp[index]['VehicleReg'] = newReg
        batch.update(vehDoc, {VehicleReg: newReg})
        batch.update(ctnDoc, {newVehicleData: newVehicleDataTemp, existingVehicleData: existingVehicleDataTemp})
        batch.commit()
        .then(() => {
          this.newVehicleData[index]['VehicleReg'] = newReg
          this.vehicleRegDialogData.itemId = null
          this.vehicleRegDialogData.Reg = null
          this.vehicleRegDialog = false
        })
        .catch(error => {
          console.log(error)
        })
      } else {
        this.vehicleRegDialogData.itemId = null
        this.vehicleRegDialogData.Reg = null
        this.vehicleRegDialog = false
      }
    },
    changeInstalledDeviceAll (templateId) {
      if (this.allItemsInstalledDevices[templateId]) {
        this.allItems[templateId] = {}
        const index = this.templates.findIndex(template => {
          return template.id === templateId
        })
        if (this.templates[index]['extras']) {
          this.templates[index].extras.forEach(extra => {
            // this.allItems[templateId][extra.name] = ''
            this.$set(this.allItems, templateId, {})
            this.allItems[templateId] = Object.assign({}, this.allItems[templateId], this.templateDefaults[templateId])
          })
        }
        this.newVehicleData.forEach((newVehicle, index) => {
          const existingIndex = index
          this.newVehicleData[index]['installedDevices'][templateId] = true
          if (this.existingVehicleData[existingIndex]['devices'][templateId]) {
            this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.existingVehicleData[existingIndex]['devices'][templateId])
          } else {
            this.$set(this.newVehicleData[index]['devices'], templateId, {})
            // this.newVehicleData[index]['devices'][templateId] = {}
            this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.newVehicleData[index]['devices'][templateId], this.templateDefaults[templateId])
          }
        })
      } else {
        this.newVehicleData.forEach((newVehicle, index) => {
          delete this.newVehicleData[index]['devices'][templateId]
          delete this.newVehicleData[index]['installedDevices'][templateId]
        })
      }
    },
    changeExtraAll (templateId, extraName) {
      const val = this.allItems[templateId][extraName]
      this.newVehicleData.forEach((newVehicle, index) => {
        let obj = this.newVehicleData[index]['devices'][templateId]
        obj[extraName] = val
        this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.newVehicleData[index]['devices'][templateId], obj)
      })
    },
    nextRow (rowIndex, extraName) {
      const nextIndex = parseInt(rowIndex) + 1
      const ref = this.$refs['edit-' + extraName + '-' + nextIndex][0].$children[0].$refs.activator
      ref.click()
    },
    openEditDialog (rowIndex, extraName) {
      setTimeout(() => {
        const ref = this.$refs['input-' + extraName + '-' + rowIndex]
        this.$nextTick(ref[0].focus())
      }, 300)
    },
    deleteOrder () {
      this.deletingOrder = true
      const deleteObj = this.deleteOrderObj
      fireStore.collection('CTN Sheets').doc(deleteObj.key).delete()
      .then(() => {
        const index = this.ctnSheetList.findIndex(ctnSheet => {
          return ctnSheet.key === deleteObj.key
        })
        this.ctnSheetList.splice(index, 1)
        this.deletingOrder = false
        this.deleteModal = false
      })
      .catch(error => {
        console.log(error)
        this.deletingOrder = false
        this.deleteModal = false
      })
    },
    deleteCtnSheetDoc (docName) {
      if (confirm('Are you sure you want to delete this document?')) {
        const storageRef = storage.ref('OrderDocs/' + this.ctnSheetRef)
        storageRef.child(docName).delete()
          .catch(error => {
            console.log(error)
          })
        const index = this.ctnSheetDocs.findIndex(doc => {
          return doc.name === docName
        })
        this.ctnSheetDocs.splice(index, 1)
        fireStore.collection('CTN Sheets').doc(this.ctnSheet).update({attachedDocs: this.ctnSheetDocs ? this.ctnSheetDocs : []})
      }
    },
    attachFile (f) {
      if (f) {
        for (let docKey in this.attachedDocs) {
          if (this.attachedDocs[docKey].file.name === f.name) {
            console.log('file exists')
            alert('File with this name already exists. Either delete the existing file or rename the file you are trying to upload')
            return false
          }
        }
        for (let docKey in this.ctnSheetDocs) {
          if (this.ctnSheetDocs[docKey].name === f.name) {
            alert('File with this name already exists. Either delete the existing file or rename the file you are trying to upload')
            console.log('file exists')
            return false
          }
        }
        this.attachedDocs.push({Progress: 0, State: 0, file: f})
      }
    },
    currencySymbolFromVal (val) {
      if (val) {
        const index = this.currencies.findIndex(currency => {
          return val === currency.value
        })
        return this.currencies[index]['text']
      }
      return null
    },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    }
  },
  computed: {
    json () {
      return JSON.stringify(this.newVehicleData)
    },
    ctnSheetItems () {
      let arr = []
      this.ctnSheetList.forEach(ctnSheet => {
        const index = this.customerList.findIndex(customerItem => {
          return ctnSheet.customer === customerItem.key
        })
        arr.push({
          id: ctnSheet.id,
          customer: this.customerList[index] && this.customerList[index]['name'] ? this.customerList[index]['name'] : '',
          key: ctnSheet.key,
          rejected: ctnSheet.rejected,
          note: ctnSheet.note,
          contacts: ctnSheet.contacts,
          LastActionDate: ctnSheet.LastActionDate,
          LastActionUser: ctnSheet.LastActionUser,
          BDM: this.customerList[index] && this.customerList[index]['BDM'] ? this.customerList[index]['BDM'] : '',
          Status: (ctnSheet.rejected ? 'Rejected' : ctnSheet.updated ? 'Resubmitted for Approval' : 'Submitted for Approval'),
          selectedTemplates: ctnSheet.selectedTemplates ? ctnSheet.selectedTemplates : this.templates,
          attachedDocs: ctnSheet.attachedDocs,
          qnq: ctnSheet.qnq,
          customerPO: ctnSheet.customerPO || ''
        })
      })
      return arr
    },
    vehicleDataHeaders () {
      let arr = []
      arr.push({
        text: 'Vehicle Reg.',
        value: 'VehicleReg',
        sortable: true,
        align: 'left'
      })
      this.selectedTemplates.forEach(template => {
        let className = ['group-header']
        if (template.visible) {
          className.push('show')
        }
        let hasExtras = false
        let hasSalesExtra = false
        for (let key in template.extras) {
          if (template.extras[key].permissions.sales === 'write') {
            hasSalesExtra = true
            break
          }
        }
        if (template.extras) {
          hasExtras = true
        }
        arr.push({
          text: template.name,
          value: template.id,
          sortable: true,
          width: '50px',
          class: className,
          hasExtras: hasExtras && hasSalesExtra,
          align: 'left'
        })
        if (template.extras && template.visible) {
          template.extras.forEach(templateExtra => {
            if (templateExtra.permissions.sales === 'write') {
              arr.push({
                text: templateExtra.name,
                value: templateExtra.name,
                sortable: true,
                class: 'col-' + template.id
              })
            }
          })
        }
      })
      return arr
    },
    username () {
      return this.$store.getters.userData.Name
    },
    user () {
      return this.$store.getters.userData
    },
    role () {
      return this.$store.getters.userData.Role
    },
    suppliers () {
      return this.$store.getters.suppliers
    }
  }
}
</script>
<style>
  .v-datatable thead th.column.sortable.active.desc i.group-hide-icon {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
.v-datatable thead th.column.sortable i.group-hide-icon {
    font-size: inherit;
    vertical-align: inherit;
    display: inherit;
    opacity: inherit;
    transition: inherit;
}

.v-datatable thead th.column.group-header {
  white-space: normal;
}
</style>


// WEBPACK FOOTER //
// OrderApproval.vue?c4268e06